<template>
  <a
    href="javascript:void(0);"
    size="small"
    type="link"
    :loading="loading"
    :class="className"
    @click="submitApproval"
    v-if="showSubmitFlg"
  >
    提交审批
  </a>
</template>

<script>
import { defineComponent, computed } from "vue";
import { ApprovalFlowService } from "../approval-flow.service";
import { message } from "ant-design-vue";
import { useStore } from "@/store";
export default defineComponent({
  name: "submit-approval-btn",
  props: {
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    bizName: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
    },
    flg: {
      type: Boolean,
    },
    access: {
      type: String,
    },
    className: {
      type: String,
    },
  },
  emits: ["refresh", "update:loading"],
  setup(props, { emit }) {
    const store = useStore();
    const { run } = ApprovalFlowService.useSubmitApi();
    const submitApproval = async () => {
      try {
        emit("update:loading", true);
        const { bizId, bizType, bizName } = props;
        let res = await run({ bizId, bizType, bizName });
        if (res.respCode !== "0000") {
          // message.error(res.respDesc);
          return;
        }
        message.success(res.respDesc);
        emit("refresh", null);
      } finally {
        emit("update:loading", false);
      }
    };
    const showSubmitFlg = computed(() => {
      let t = store.state.user.buttons[props.access || ""];
      return t && props.flg;
    });
    return {
      run,
      submitApproval,
      showSubmitFlg,
    };
  },
});
</script>

<style scoped></style>
